export default "__VITE_ASSET__98246825__"